export default __webpack_public_path__ + "static/media/hht2_ep6_speaking_04.c2a7a35d.png";